import { render, staticRenderFns } from "./BaseSuperButton.vue?vue&type=template&id=1586c3a3&"
import script from "./BaseSuperButton.vue?vue&type=script&lang=js&"
export * from "./BaseSuperButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseSuperButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
